import * as React from 'react';

const SvgCommentFilled = (props) => React.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React.createElement("path", { fill: "#2D2E2E", d: "M17 7H7v2h10V7ZM15 11H7v2h8v-2Z" }),
  React.createElement("path", { fill: "#2D2E2E", d: "M2 2v16h8v-2H4V4h16v12h-5.47L9.5 22h2.61l3.36-4H22V2H2Z" })
);

export { SvgCommentFilled as default };
//# sourceMappingURL=CommentFilled.es.js.map
